import type { Patient } from '@medplum/fhirtypes';

// Limitación del tratamiento POR PACIENTE (MT-087, LOPDP art. 19). La bóveda (lib/limitacion.ts) es la fuente de verdad y refleja la limitación vigente en
// `Patient.meta.security` con esta etiqueta. La ficha solo la LEE para mostrar el aviso: no limita ni levanta nada. Pura: recibe el Patient, devuelve sí/no.

/** Debe coincidir con `SISTEMA_LIMITACION` / `CODIGO_LIMITACION` de packages/web/src/api/lib/limitacion.ts. */
export const SISTEMA_LIMITACION = 'http://logiacare.ec/fhir/security/limitacion-tratamiento';
export const CODIGO_LIMITACION = 'limitado';

export function tratamientoLimitado(patient: Pick<Patient, 'meta'> | null | undefined): boolean {
  return (patient?.meta?.security ?? []).some((c) => c.system === SISTEMA_LIMITACION && c.code === CODIGO_LIMITACION);
}
